import { FC } from 'react';
import { DashboardConnectorType } from '../../../models/StudentDashboard';
import { useUnitConnectorColors } from '../../../hooks/useUnitConnectorColors';

interface Props {
  type: DashboardConnectorType;
}

export const PathEndNode: FC<Props> = ({ type }) => {
  const connectorColors = useUnitConnectorColors();
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      {type === 'locked' ? (
        <circle cx="7.5" cy="7.5" r="7.5" fill="#BAAF9F" />
      ) : (
        <circle cx="7.5" cy="7.5" r="7.5" className={connectorColors.fillAccent} />
      )}
    </svg>
  );
};
